import { ActiveCouponCardSkeleton, MediaQuery } from '@pelando/components';
import styled, { css } from 'styled-components';
import EmptyState from '../../../components/EmptyState';

const StoreCouponsTabContainerStyles = css`
  width: 100%;

  padding: 0 16px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    padding: 0;
  }
`;

export const StoreCouponsTabContainer = styled.ul`
  ${StoreCouponsTabContainerStyles}
  display: flex;
  flex-direction: column;
  height: max-content;
`;

export const StoreCouponsTabContainerSkeleton = styled.div`
  ${StoreCouponsTabContainerStyles}
  margin-bottom: 16px;
`;

export const CouponStoreCardSkeleton = styled(ActiveCouponCardSkeleton)`
  margin-bottom: 8px;
  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const CouponsEmptyState = styled(EmptyState)`
  margin-top: 48px;
  margin-bottom: 120px;

  @media ${MediaQuery.SCREEN_MD_UP} {
    margin: 112px 0;
  }
`;
